import { render, staticRenderFns } from "./RateSection.vue?vue&type=template&id=0d0fef12&"
import script from "./RateSection.vue?vue&type=script&lang=js&"
export * from "./RateSection.vue?vue&type=script&lang=js&"
import style0 from "./RateSection.vue?vue&type=style&index=0&id=0d0fef12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports